import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import './WalkthroughPopover.scss';

export class WalkthroughPopover extends Component {
  handleNext() {
    this.props.actions.nextWalkthroughStep();
  }

  handleRequestClose(event, data) {
    this.props.actions.closeWalkthrough();
  }

  mapPositionPropToCssClasses(position) {
    switch (position && position.toLowerCase()) {
      case 'left':
        return {
          element: 'left-center',
          nubbin: 'slds-nubbin_right'
        };
      case 'left-bottom':
        return {
          element: 'left-bottom',
          nubbin: 'slds-nubbin_right-top'
        };
      case 'right-bottom':
        return {
          element: 'right-bottom',
          nubbin: 'slds-nubbin_left-top'
        };
      case 'right':
      default:
        return {
          element: 'right-center',
          nubbin: 'slds-nubbin_left'
        };
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { position, numSteps, step } = this.props;
    const { isOpen, isLast, stepNum } = step;

    const headingText = formatMessage({
      id: `WalkthroughPopover.steps.${step.key}.heading`
    });
    const bodyText = formatMessage({
      id: `WalkthroughPopover.steps.${step.key}.body`
    });
    const stepDescriptionText = (
      <FormattedMessage
        id="WalkthroughPopover.footer.stepDescription"
        values={{
          stepNum: stepNum,
          numSteps: numSteps
        }}
      />
    );
    const closeButtonLabelText = isLast
      ? formatMessage({ id: 'WalkthroughPopover.footer.done' })
      : formatMessage({ id: 'WalkthroughPopover.footer.skip' });
    const css = this.mapPositionPropToCssClasses(position);
    css.open = isOpen ? 'open' : 'hidden';

    return (
      <section
        aria-describedby={`walthroughstep-${step.key}__body`}
        aria-labelledby={`walthroughstep-${step.key}__header`}
        className={`walkthrough-popover ${
          css.open
        } slds-popover slds-popover_walkthrough ${css.nubbin} ${css.element}`}
        role="dialog"
      >
        <Button
          className="slds-float_right slds-popover__close"
          assistiveText={{ icon: 'Close popover' }}
          iconCategory="utility"
          iconName="close"
          iconSize="small"
          variant="icon"
          inverse
          onClick={() => this.handleRequestClose()}
        />
        <header className="slds-popover__header">
          <h2
            id={`walthroughstep-${step.key}__header`}
            className="slds-text-heading_medium"
          >
            {headingText}
          </h2>
        </header>
        <div
          className="slds-popover__body"
          id={`walthroughstep-${step.key}__body`}
        >
          <p>{bodyText}</p>
        </div>
        <footer className="slds-popover__footer">
          <div className="slds-grid">
            <span className="slds-col">{stepDescriptionText}</span>
            <div className="slds-text-align_right slds-col slds-no-flex">
              <Button
                label={closeButtonLabelText}
                onClick={() => this.handleRequestClose()}
              />
              {!isLast ? (
                <Button
                  variant="brand"
                  label={formatMessage({
                    id: 'WalkthroughPopover.footer.next'
                  })}
                  onClick={() => this.handleNext()}
                />
              ) : null}
            </div>
          </div>
        </footer>
      </section>
    );
  }
}

WalkthroughPopover.propTypes = {
  step: PropTypes.object.isRequired,
  numSteps: PropTypes.number.isRequired,
  position: PropTypes.oneOf(['left', 'left-bottom', 'right', 'right-bottom']),
  children: PropTypes.element,
  location: PropTypes.object,
  actions: PropTypes.object.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(WalkthroughPopover);
